import {    
    GET_INFO_CHAT,    
} from "../Actions/chat-button.types";

const initialState = -1;

const chatButtonReducer = function (state=initialState, action) {
    const {type, payload } = action;    
    switch (type) {        
        case GET_INFO_CHAT:
            return {
                ...state,
                textoInformativo: payload.data.aCChatContenido
            }        
        default:
            return state;
    }
};

export default chatButtonReducer;